import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/de';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import LocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

import classes from './SimplDatepicker.scss';
import parseDate from '../../helpers/parseDate';

class SimplDatepicker extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('de');

    let date = this.validateDate(props.defaultValue);

    this.state = {
      date,
      focused: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    let date = this.validateDate(nextProps.defaultValue);

    if (date) {
      this.setState({
        date,
      });
    }
  }

  validateDate = newDate => {
    let date;

    if (moment.isMoment(newDate)) {
      date = newDate;
    } else if (newDate !== null && newDate.length) {
      if (
        typeof props !== 'undefined' &&
        moment(newDate, props.dateFormatSubmit).isValid()
      ) {
        date = moment(newDate, props.dateFormatSubmit);
      } else if (
        typeof this.props !== 'undefined' &&
        moment(newDate, this.props.dateFormatSubmit).isValid()
      ) {
        date = moment(newDate, this.props.dateFormatSubmit);
      } else if (moment(newDate).isValid()) {
        date = moment(newDate);
      }

      date = date.toISOString();
    }

    return date;
  };

  handleDayChange = (date, modifiers) => {
    this.setState({
      date,
      isDisabled: modifiers.disabled,
    });

    if (typeof date !== 'undefined') {
      this.props.onChange(date.format(this.props.dateFormatSubmit), date);
    } else {
      this.props.onChange(null, null);
    }
  };

  handleDayBlur = e => {
    const valueRightNow = e.target.value;
    setTimeout(() => {
      const valueAfterParsing = e.target.value;
      if (
        String(valueRightNow) === String(valueAfterParsing) &&
        valueAfterParsing.length
      ) {
        // date stayed the same, meaning the parser did not work yet
        const date = parseDate(valueAfterParsing);

        this.setState({ date: date.toISOString() });
        this.props.onChange(date.format(this.props.dateFormatSubmit), date);
      }
    }, 500);
  };

  render() {
    const formattedDay = this.state.date
      ? moment(this.state.date).format(this.props.dateFormat)
      : '';

    const disabled = {};

    if (this.props.minDate.length || moment.isMoment(this.props.minDate)) {
      if (moment.isMoment(this.props.minDate)) {
        disabled.before = this.props.minDate.toDate();
      } else {
        disabled.before = moment(this.props.minDate).toDate();
      }
    }

    const dayPickerProps = {
      todayButton: 'Zum aktuellen Monat',
      disabledDays: disabled,
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
      localeUtils: LocaleUtils,
      locale: 'de',
    };

    return (
      <div className={this.props.right ? classes.right : null}>
        <DayPickerInput
          value={formattedDay}
          onDayChange={this.handleDayChange}
          format={this.props.dateFormat}
          placeholder={`bspw. ${moment()
            .locale('de')
            .format(this.props.dateFormat)}`}
          dayPickerProps={dayPickerProps}
          onBlur={this.handleDayBlur}
        />
      </div>
    );
  }
}

SimplDatepicker.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dateFormat: PropTypes.string,
  dateFormatSubmit: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  right: PropTypes.bool,
};

SimplDatepicker.defaultProps = {
  defaultValue: '',
  minDate: '',
  dateFormat: 'DD.MM.YYYY',
  dateFormatSubmit: 'YYYY-MM-DD',
  right: false,
};

export default SimplDatepicker;



// WEBPACK FOOTER //
// ./src/components/SimplDatepicker/SimplDatepicker.js